module.exports = __webpack_public_path__ + "static/media/S2N3-2.94ab3f36.svg";